import React from 'react';

import { CmBox, CmFlex, CmIconButton, CmText } from '@/components/uiParts';
import { CloseIcon } from '@/components/uiParts';
import { CustomLinkedStoreItem } from '@/domain/models/LinkItem';

interface Props {
  item: CustomLinkedStoreItem;
  groupIndex: number;
  itemIndex: number;
  handleDeleteGroupItem: (groupIndex: number, itemIndex: number) => void;
}

export const LinkedItem: React.FC<Props> = ({
  item,
  groupIndex,
  itemIndex,
  handleDeleteGroupItem,
}) => {
  const { item_name, delivery_service_name } = item;

  return (
    <CmBox
      w="100%"
      bg="white"
      rounded="md"
      display="flex"
      shadow="md"
      borderColor="gray.50"
      borderStyle="solid"
      border="1px"
      p={2}
    >
      <CmFlex justifyContent="space-between" alignItems="center" w="100%">
        <CmText>
          {item_name}（{delivery_service_name}）
        </CmText>
        {/*
         // @ts-ignore TS2590 */}
        <CmIconButton
          aria-label="Checked Notification"
          icon={<CloseIcon />}
          onClick={(e) => {
            e.stopPropagation();
            handleDeleteGroupItem(groupIndex, itemIndex);
          }}
        />
      </CmFlex>
    </CmBox>
  );
};
